import TYPES from '../../action-types';
import Logger from '../../../services/Logger';

const deselectAllByMatch = () => (dispatch, getAll) => {
  const { items } = getAll().assets;
  Logger.log('User', 'BMMDeselectAllToolbarClicked', { selectedCount: items.length });
  dispatch({
    type: TYPES.ASSETS.DESELECT_ALL_BY_MATCH,
    payload: {},
  });
  window.dispatchEvent(new Event('selection:switched:off'));
};

export default deselectAllByMatch;
